import { callAuthorizedGraphQLEndpoint } from '../../../../../Module/graphQL'
import { callAuthorizedGraphQLEndpoint as callAuthorizedPathfinderGraphQLEndpoint } from '../../../../../Module/graphQL/PathFinder/pathFinderGQL'
/** @import { Campaign } from './utils' */

const getClientRecipientsEmailData = clientId => {
  const query = `query clientRecipientsEmailData($clientId:ID!){
      clientRecipientsEmailData(clientId:$clientId){
       recipients
       cc
      }
    }`

  return callAuthorizedGraphQLEndpoint(query, {
    clientId,
  })
}

/**
 * @param {{
 *   countryId?: string,
 *   clientId?: string,
 *   cityId?: string,
 *   statuses?: string[]
 *   campaignId?: string,
 *   includePathfinder?: boolean,
 *   first?: number,
 *   skip?: number,
 *   reviewMeetingDate?: string,
 *   dateRange?: {
 *     start?: string,
 *     end?: string,
 *   },
 *   searchString?: string,
 *   internalStatus?: string[],
 *   type?: string[],
 *   subtype?: string[],
 * }} input
 *
 * @returns {Promise<Omit<Campaign,'draftStep'>[]>}
 */
export async function campaignsBuilderData(input) {
  const query = `query campaignsBuilderData($input: campaignsBuilderDataInput){
      campaignsBuilderData(input: $input){
        totalCount 
        nodes {
          id
          campaignId
          startDate
          internalStatus
          flyerType
          flyerWeight
          flyerCount
          flyerDesign {
            s3Link
            s3ThumbnailLink
            fileName
            format
            createdAt
            author {
              firstName
              lastName
            }
          }
          error
          campaignDuration
          missionsCount
          totalCosts
          taxes
          lastActiveStep
          clientName
          campaignName
          type
          subtype
          submitDate
          internalStatusChangedDate
          paymentIntent
          paymentStatus
          clientId
          isPaymentSkipped
          paymentSkipperId
          dynamicCouponCode
          staticCouponCode
          submitter{
            firstName
            lastName
          }
          cityName
          isArchivedCity
          createdAt
          printerJobs {
            edges {
              node {
                printerName
                mailPieces
              }
            }
          }
        }
      }
    }`

  const response = await callAuthorizedGraphQLEndpoint(query, { input })
  const { data, error } = await response.json()
  if (data) {
    return data.campaignsBuilderData.nodes
  }

  throw new Error(`error fetching campaignsBuilderData: ${error}`)
}

const updateCampaignsCampaignBuilderData = input => {
  const query = `mutation updateCampaignExtraData(
      $input: CampaignExtraDataInput
    ) {
      updateCampaignExtraData(
        input: $input,
      ) { 
        success
        error
      }
    }`

  return callAuthorizedGraphQLEndpoint(query, input)
}

const sendEmail = input => {
  const query = `mutation sendEmail(
      $input: SendEmailInput
    ) {
      sendEmail(
        input: $input,
      ) { 
        success
        recipient
      }
    }`

  return callAuthorizedGraphQLEndpoint(query, input)
}

const getCampaignFlyerInfo = async campaignId => {
  const query = `query 
    ($campaignId:ID!) {
        campaignFlyerInfo(campaignId: $campaignId) {
          s3Link
          flyerName
        }
    }`

  return await callAuthorizedGraphQLEndpoint(query, {
    campaignId,
  })
}

const updateSelfServeCampaignData = input => {
  const gql = `mutation($input: SelfServeCampaignDataInput!) {
      updateSelfServeCampaignData(input: $input) {
          success
      }
    }`

  return callAuthorizedPathfinderGraphQLEndpoint(gql, {
    input,
  })
}

const createEDDMInternalFlyerCodes = input => {
  const query = `mutation createEDDMInternalFlyerCodes(
      $input: CreateEDDMInternalFlyerCodesInput!
    ) {
      createEDDMInternalFlyerCodes(
        input: $input,
      ) { 
        success
      }
    }`
  return callAuthorizedGraphQLEndpoint(query, { input })
}

const createCityPlanAndMissionOnSSCampaign = input => {
  const query = `mutation createCityPlanAndMissionOnSSCampaign(
      $input: CreateCityPlanAndMissionOnSSCampaignInput!
    ) {
      createCityPlanAndMissionOnSSCampaign(
        input: $input,
      ) { 
        success
      }
    }`
  return callAuthorizedGraphQLEndpoint(query, { input })
}

/**
 * @param {string} countryId
 * @returns { Promise<{ edges: { node: { id: string, name: string } }[] }> }
 */
async function citiesByCountry(countryId) {
  const query = `query citiesByCountry($countryId: ID!) {
    cities(countryId: $countryId) {
      edges {
        node {
          id
          name
        }
      }
    }
  }`

  const response = await callAuthorizedGraphQLEndpoint(query, { countryId })
  const body = await response.json()
  if (body.data) {
    return body.data.cities
  }

  throw new Error(body.error || 'graphql error')
}

export {
  getClientRecipientsEmailData,
  updateCampaignsCampaignBuilderData,
  sendEmail,
  getCampaignFlyerInfo,
  updateSelfServeCampaignData,
  createEDDMInternalFlyerCodes,
  createCityPlanAndMissionOnSSCampaign,
  citiesByCountry,
}
